/**
 * @generated SignedSource<<23b70195745a9993d7a2af5c61fffef3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UnfollowTopicInput = {
  topicSlug: string;
};
export type FollowingPageUnfollowMutation$variables = {
  input: UnfollowTopicInput;
};
export type FollowingPageUnfollowMutation$data = {
  readonly unfollowTopic: {
    readonly topic: {
      readonly followerCount: number;
      readonly id: string;
      readonly isFollowedByViewer: boolean | null | undefined;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly field: string | null | undefined;
      readonly message: string;
    }>;
  };
};
export type FollowingPageUnfollowMutation = {
  response: FollowingPageUnfollowMutation$data;
  variables: FollowingPageUnfollowMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UnfollowTopicPayload",
    "kind": "LinkedField",
    "name": "unfollowTopic",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Topic",
        "kind": "LinkedField",
        "name": "topic",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isFollowedByViewer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followerCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FollowingPageUnfollowMutation",
    "selections": (v1/*: any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FollowingPageUnfollowMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ad81e1b371c9d685acd439ad692b5ab4",
    "id": null,
    "metadata": {},
    "name": "FollowingPageUnfollowMutation",
    "operationKind": "mutation",
    "text": "mutation FollowingPageUnfollowMutation(\n  $input: UnfollowTopicInput!\n) {\n  unfollowTopic(input: $input) {\n    topic {\n      id\n      isFollowedByViewer\n      followerCount\n    }\n    userErrors {\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1af3b0cbdca200c5ca0464c5fc850f42";

export default node;
